import { builder } from '@builder.io/sdk'
import builderConfig from '../../../builder-config'

const apiKey = builderConfig?.builderAPIKey

builder.init(apiKey) // Initialize Builder with your API key

export const getBuilderAPI = (model, apiKey, slug) => {
    switch (model) {
        //add more models here, if needed
        case 'landing-page':
            return {
                fetchUrl: `https://cdn.builder.io/api/v3/content/${model}?apiKey=${apiKey}&query.data.pageUrl=${slug}&cachebust=true`,
            }
        default:
            return {
                fetchUrl: `https://cdn.builder.io/api/v3/content/${model}?apiKey=${apiKey}&url=${slug}&cachebust=true`,
            }
    }
}

export const getBuilderData = async (builderModelName, options) => {
    // Check if the model name is provided
    if (!builderModelName) {
        throw new Error('Builder model name is required.')
    }

    try {
        const content = await builder
            .get(builderModelName, {
                apiKey: process.env.BUILDER_API_KEY,
                ...options,
            })
            .toPromise()

        return content // Return the successful result
    } catch (error) {
        console.error('Error fetching builder data:', error.message || error)
    }
}
